import React, { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap } from 'react-icons/fi';
import { Link, useParams } from 'react-router-dom';


import { MdError } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';

import Button from '../../../../components/Forms/Button';
import Loader from '../../../../components/Loader';
import MaskedInput from '../../../DashboardPages/core/components/Forms/MaskedInput';
import { ResponseMessage } from '../../../../components/ResponseMessage';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { Error, Separator, Container, FixedResponse } from './styles';
import SelectSimple from '../../../../components/Forms/SelectSimple';
import Whatsapp from '../../../../components/WhatsAppCompartilhar';

import JsonListMultiple from '../../../../components/Forms/JsonListMultiple';

import api from '../../../../services/api';
import { authTitle, defaultProjectHash, eventName, recaptchaKey, urlWebsite } from '../../../../config';
import getCep from '../../../../services/cep';
import { FaBuilding, FaGenderless, FaIdBadge, FaPhone } from 'react-icons/fa';
import CheckboxInput from '../../../../components/Forms/CheckboxInput';
import { useLanguage } from '../../../../hooks/Language';
import TextareaInput from '../../../../components/Forms/TextareaInput';
import { areas } from './areas';
import CheckboxIncluder from './components/CategoryChange';
import { modalidade } from './modalidade';
import { useToast } from '../../../../hooks/Toast';
import { useModal } from '../../../../hooks/Modal';
import CheckboxInputJSON from '../../../DashboardPages/core/components/Forms/CheckboxInputJson';
import { sub } from 'date-fns';
import { useConfiguration } from '../../../../hooks/Configuration';
import Input from '../../../DashboardPages/core/components/Forms/Input';


interface IRecoverFormData {
  [key: string]: any
}

interface ICaptcha {
  getValue(): string;
}

interface IOption {
  label: string;
  value: string;
  id: string;
}

const MonitorSubscription: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(true);
  const formRef = useRef<FormHandles>(null);
  const { configuration } = useConfiguration();
  const { hash, projectHash = configuration?.url } = useParams<Record<string, any>>();
  const [submissionData, setSubmissionData] = useState<Record<string, any>>({});
  const recaptchaRef = useRef(null);
  const { translate } = useLanguage();
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
  const { addToast } = useToast();
  const [haveAgency, setHaveAgency] = useState('Não');
  const [activeReview, setActiveReview] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [category, setCategory] = useState([]);
  const [area, setArea] = useState('');
  const [subarea, setSubarea] = useState('');
  const [countryISO, setCountryISO] = useState('BR');

  const [categoryOptions, setCategoryOptions] = useState<Array<IOption>>([]);
  const [areaOptions, setAreaOptions] = useState<Array<IOption>>([]);
  const [subareaOptions, setSubareaOptions] = useState<Array<IOption>>([]);

  const [initialData, setInitialData] = useState({});

  const [submission, setSubmission] = useState<Record<string, any>>();

  const hours = submission?.monitor_hour_fields?.reduce((prev, item) => {

    if (item?.options?.length > 0) {

      item?.options?.map(avaliableHour => {

        prev.push({ id: `${avaliableHour}`, label: `${avaliableHour}`, value: { hour: avaliableHour } });


      })

    }

    return prev

  }, [])


  const loadSubmission = async () => {


    const response = await api.get(`/get-submission-selection/evento/4-congresso-ufcspa`);

    if (response?.data) {
      setSubmission(response?.data);

    }

  }


  useEffect(() => {

    const areaOptions: Array<IOption> = [];

    areas.map(a => {
      areaOptions.push({ label: a.title, value: a.title, id: a.title });
    })

    setCategoryOptions(areaOptions);

    loadSubmission();


  }, [hash])



  useEffect(() => {

    const areaOptions: Array<IOption> = [];

    areas.map(a => {
      areaOptions.push({ label: a.title, value: a.title, id: a.title });
    })

    setCategoryOptions(areaOptions);

  }, [])


  const box = (dataInfo, key = '') => {
    if (!dataInfo) {
      return <></>
    }
    return <>
      {dataInfo.map(d => <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{key === 'self' ? d || '' : d?.[key] || ''}</aside>)}
    </>
  }


  const checkCategoria = (category, area) => {

    const categoryList = area.finIndex(a => a.title === category);

    if (!category) {
      addToast({ title: 'Campo categoria de submissão é obrigatório' });
      setLoading(false);
      return;
    }

  }

  const handleNewLogin = async (data: IRecoverFormData) => {




    setLoading(true);





    if (data?.hours?.length < submission?.monitor_hour_fields?.[0]?.minimun) {
      addToast({ title: `Selecione ao menos ${submission?.monitor_hour_fields?.[0]?.minimun} horário(s)`, type: 'error' });
      setLoading(false);
      return;
    }


    try {
      formRef.current?.setErrors({});





      const shape: Record<string, any> = {
        name: Yup.string().required('O campo Nome é obrigatório'),
        document_number: Yup.string().required('O campo CPF é obrigatório'),

        email: Yup.string().required('O campo Email é obrigatório'),
        category_id: Yup.string().required('O campo Curso é obrigatório'),

        position_list: Yup.string().required('O campo Programa é obrigatório'),

      };

      if (data?.email?.toLowerCase()?.indexOf('ufcspa') < 0) {

        shape.company = Yup.string().required('O campo Instituição é obrigatório');
      }
      else {
        data.company = 'UFCSPA';
      }





      const schema = Yup.object().shape(shape);

      await schema.validate(data, { abortEarly: false });



      if (!activeReview) {
        setSubmissionData(data);
        setActiveReview(true);
        setLoading(false);
        return;
      }




      const response = await api.post(`/signup-monitor/evento/4-congresso-ufcspa`, {
        ...data,
        project_id: projectHash

      });

      setSuccess(true);
      setLoading(false);
      window.scrollTo(0, 0)
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      setActiveReview(false);

      setErrorMessage([
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Erro ao gerar seu cadastro',
      ]);
    }
    setLoading(false);
  };

  const [categoryValue, setCategoryValue] = useState('');
  const [email, setEmail] = useState<string>('');
  const { addModal } = useModal();



  const [ended, setEnded] = useState(false);

  if (ended) {
    return <Container style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>

      <h2 style={{ background: 'rgb(0,14,64)', color: '#fff', padding: '15px', marginBottom: '15px' }}>Inscrições de monitor encerrada</h2>
      <Link to={`/`}><Button>Voltar para o site</Button></Link>
    </Container>
  }

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside style={{
        width: '100%',
        padding: '20px'
      }}>
        {success ? (<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <ResponseMessage
            active
            type="success"
            title="Sucesso"
            description={
              <><p style={{ color: '#333' }}>
                Cadastro realizado com sucesso!
                <br />


              </p>
                <aside style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <Link to={`/`} style={{ width: 'auto' }}><button className="defaultButton">Voltar para o site</button></Link>
                </aside></>
            }
          /></div>
        ) : (<Container>
          <Form ref={formRef} initialData={initialData} onSubmit={handleNewLogin} style={{ maxWidth: '800px' }}>
            <h1>{authTitle}</h1>
            <p>Cadastro de Monitores</p>

            <Separator>


              <label>Dados do Monitor</label>
              <Input name="name" placeholder="Nome Completo" />
              <MaskedInput mask="999.999.999-99" name="document_number" placeholder="CPF" />

              <Input name="email" placeholder="Email" setCallback={(emailValue) => { setEmail(emailValue) }} />
              {email?.indexOf('@') >= 0 && email?.indexOf('.') >= 0 && email?.toLowerCase()?.indexOf('ufcspa') < 0 ? <Input type="text" name="company" placeholder="Instituição" /> : <></>}

              {email?.toLowerCase()?.indexOf('ufcspa') >= 0 ? <label>Instituição: UFCSPA</label> : <></>}


              <SelectSimple setCallback={(value) => setCategoryName(value)} label='Curso que está matriculado na UFCSPA' name='category_id' options={[


                { label: 'Biomedicina Integral', value: 'Biomedicina Integral' },
                { label: 'Biomedicina Noturno', value: 'Biomedicina Noturno' },
                { label: 'Enfermagem', value: 'Enfermagem' },
                { label: 'Farmácia', value: 'Farmácia' },
                { label: 'Física Médica', value: 'Física Médica' },
                { label: 'Fisioterapia', value: 'Fisioterapia' },
                { label: 'Fonoaudiologia', value: 'Fonoaudiologia' },
                { label: 'Gastronomia', value: 'Gastronomia' },
                { label: 'Gestão em Saúde', value: 'Gestão em Saúde' },
                { label: 'Informática Biomédica', value: 'Informática Biomédica' },
                { label: 'Medicina', value: 'Medicina' },
                { label: 'Nutrição', value: 'Nutrição' },
                { label: 'Psicologia', value: 'Psicologia' },

                { label: 'Química Medicinal', value: 'Química Medicinal' },

                { label: 'Tecnologia em Alimentos', value: 'Tecnologia em Alimentos' },
                { label: 'Toxicologia Analítica', value: ' Toxicologia Analítica' },
                { label: 'Outro', value: 'Outro? Qual?' },
              ]} />

              {categoryName === 'Outro? Qual?' ?
                <Input name='category_id' placeholder='Qual curso?' />

                : <></>}

              <p style={{ color: '#333', padding: '0px', paddingTop: '20px' }}>Programa(s) que está vinculado?</p>
              <CheckboxInput placeholder=''
                name='position_list'
                options={[
                  { label: 'PID', value: 'PID', id: 'PID' },
                  { label: 'IC/ITI', value: 'IC/ITI', id: 'IC/ITI' },
                  { label: 'Extensão', value: 'Extensão', id: 'Extensão' },
                  { label: 'Pós-graduação', value: 'Pós-graduação', id: 'Pós-graduação' },
                  { label: 'Outro', value: 'Outro', id: 'Outro' },
                ]}
              />

            </Separator>












            <Separator>
              <label>Disponibilidade de horários - registre no mínimo {submission?.monitor_hour_fields?.[0]?.minimun} horários</label>



              <CheckboxInputJSON name="hours" options={
                hours || []
              } placeholder="" />
            </Separator>

            {/*  <Separator>
              <label>3 - Número de resumos para avaliação</label>
              <CheckboxInput unique name="papers_numbers" options={
                [
                  { value : '5 a 8', id:'5 a 8', label: '5 a 8'},
                  { value : '9 a 11', id:'9 a 11', label: '9 a 11'},
                  { value : '12 a 14', id:'12 a 14', label: '12 a 14'}
                ]
              } placeholder="" />

            </Separator> */}






            {errorMessage && (
              <Error>
                {errorMessage.map((item, index) => (
                  <div key={`error${index}`}>
                    <MdError />
                    {item}
                  </div>
                ))}
              </Error>
            )}

            <aside style={{ display: 'flex', justifyContent: 'center' }}>
              <Button style={{ width: '100%' }} type="submit">
                Enviar
              </Button>
            </aside>

            <FixedResponse style={{ display: activeReview ? 'flex' : 'none' }}>
              <div>
                <h1>Revisão de dados</h1>

                <h2>Dados do Monitor</h2>
                <strong>Nome completo</strong><p>{submissionData?.name}</p>
                <strong>CPF</strong><p>{submissionData?.document_number}</p>
                <strong>Email</strong><p>{submissionData?.email}</p>

                <strong>Instituição</strong><p>{submissionData?.company}</p>
                <strong>Curso</strong><p>{submissionData?.category_id}</p>
                <strong>Programa(s)</strong><p>{submissionData?.position_list?.join(', ')}</p>


                <h2>Horários</h2>

                {submissionData?.hours?.map(hourValue => {
                  return <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{hourValue}</aside>
                })}



                <button className="buttonBigGreen" type="submit" style={{ width: '200px', padding: '15px' }}>Enviar</button>


                <button className="defaultButtonReverse" type="button" onClick={() => setActiveReview(false)}>Editar</button>
              </div>

            </FixedResponse>
          </Form>
        </Container>
        )}
      </aside>


    </>
  );
};

export default MonitorSubscription;

